// Contentful-mirrored tier ladder for Function-based discounts the Admin API
// cannot read (Bundle Friendly Discount). Mirror entries live in
// settings.tieredDiscount.tiers as "qty|pct" strings, e.g. "2|20" = 2 items → 20%.
// An optional collection GID in settings.tieredDiscount.tiersCollection scopes
// the counting to that collection (the Function counts only products in e.g.
// "All products - Excl. Travel/Dispenser/Giftbox/Stieglitz"); without it the
// mirror counts all cart lines.
// IMPORTANT: the mirror must be kept in sync with the Function config by hand.
// Known gap (pre-existing): the display counts plain line quantities, so the
// Function's "bundles count as 2" semantics are NOT reflected in the bar.

export const parseTierMirror = (entries, collectionId) =>
  (entries || [])
    .map(entry => {
      const [qtyRaw, pctRaw] = String(entry).split('|');
      const minimumQuantity = parseInt(qtyRaw, 10);
      const pct = parseFloat(pctRaw);
      if (!minimumQuantity || Number.isNaN(pct) || pctRaw === '' || pctRaw === undefined) {
        return null;
      }
      const scope = collectionId
        ? { eligibleCollections: [{ id: collectionId }], allItems: false }
        : { allItems: true };
      return { minimumQuantity, discountPercentage: pct / 100, ...scope };
    })
    .filter(Boolean)
    .sort((a, b) => a.minimumQuantity - b.minimumQuantity);

export const resolveTiers = (shopifyTiers, mirrorEntries, collectionId) => {
  const readable = (shopifyTiers || []).filter(t => t.minimumQuantity);
  if (readable.length) return shopifyTiers;
  return parseTierMirror(mirrorEntries, collectionId);
};
